import React from 'react';
import { useHistory } from 'react-router-dom';
import { resolveStrapiImgUrl } from '@app/utils';
import routes from '@routes';
import Button from '@components/Button';
import { ExperienceItem } from '@app/utils/types';
import { observer } from 'mobx-react-lite';
import {
  Container,
  Content,
  Title,
  Description,
  DescWrap,
  CarouselItemWrapper,
  TextsWrapper,
} from './styles';
import { useEventSlug } from '@app/hooks/useEventSlug';
import { useTrackMarketoLinkClick } from '@app/hooks';
import useMobile from '@app/hooks/useMobile';

interface ItemProps {
  item: ExperienceItem;
  isCarousel?: boolean;
}

const BigExperienceItem = ({
  isCarousel,
  item: { slug, title, description, preExperienceBackground, carouselBtnText },
}: ItemProps) => {
  const history = useHistory();
  const eventSlug = useEventSlug();
  const isMobile = useMobile();
  const trackLink = useTrackMarketoLinkClick();

  const bgImage = resolveStrapiImgUrl(preExperienceBackground);

  const handleRedirect = () => {
    trackLink();
    history.push(routes.EVENT.EXPERIENCE(slug, eventSlug));
  };

  if (isCarousel) {
    return (
      <CarouselItemWrapper>
        <Container
          image={bgImage}
          {...(isMobile && { onClick: handleRedirect })}
        />
        <Content isCarousel={isCarousel}>
          <TextsWrapper>
            <Title>{title}</Title>
            <DescWrap>
              <Description>{description}</Description>
            </DescWrap>
          </TextsWrapper>

          <Button
            title={carouselBtnText}
            fontSize={14}
            onClick={handleRedirect}
          />
        </Content>
      </CarouselItemWrapper>
    );
  }

  return (
    <Container image={bgImage}>
      <Content>
        <TextsWrapper>
          <Title>{title}</Title>
          <DescWrap>
            <Description>{description}</Description>
          </DescWrap>
        </TextsWrapper>

        <Button
          title={carouselBtnText}
          fontSize={14}
          onClick={handleRedirect}
        />
      </Content>
    </Container>
  );
};

export default observer(BigExperienceItem);
